import { withParams, ref } from 'vuelidate/lib/validators/common';

export var different = function different(otherProp) {
    return withParams({ type: 'different', otherProp: otherProp }, function (value, parentVm) {
        return value !== ref(otherProp, this, parentVm);
    });
};


//////////////////
// WEBPACK FOOTER
// ./src/validators/different.js
// module id = ./src/validators/different.js
// module chunks = 0 1 2 3 4 6 7 8 9 10 11 12 14 15 16